import { isEmpty } from 'lodash/fp';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import * as actionTypes from 'constants/actionTypes';
import { toggleUpdateEmailConfirmation } from './eventChangeManagement';

export function updateEvent(changes) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { event } = getState();
      request
        .putJSON(routes.IN_PERSON_TRAINING.EVENT(event.id), { event: changes })
        .then(res => {
          if (res.success) {
            dispatch({
              type: actionTypes.IN_PERSON_TRAINING.EVENT.UPDATE,
              event: res.event,
            });
            /**
             * We're only asking users to confirm sending an update email when:
             * A) the event being edited is in the future (there's an upcoming session)
             * B) the user has changed some attributes (changed_attributes not empty)
             * C) there are invitees listed on the event
             */
            if (
              event.next_session &&
              !isEmpty(res.changed_attributes) &&
              res.event.has_invitees
            ) {
              dispatch(
                toggleUpdateEmailConfirmation({
                  resource: {
                    id: event.id,
                    type: 'Event',
                  },
                  changedAttributes: res.changed_attributes,
                }),
              );
            }
            resolve(res);
          } else {
            reject();
          }
        })
        .fail(reject);
    });
}

export function reloadEvent() {
  return (dispatch, getState) => {
    const { event } = getState();
    request.get(routes.IN_PERSON_TRAINING.EVENT(event.id)).then(res => {
      dispatch({
        type: actionTypes.IN_PERSON_TRAINING.EVENT.UPDATE,
        event: res.event,
      });
    });
  };
}

export function requestEvent(eventId) {
  return dispatch => {
    dispatch({
      type: actionTypes.IN_PERSON_TRAINING.EVENT.DATA_REQUEST,
    });
    request
      .get(routes.IN_PERSON_TRAINING.EVENT(eventId))
      .then(res => {
        dispatch({
          type: actionTypes.IN_PERSON_TRAINING.EVENT.DATA_RECEIVE,
          event: res.event,
          sessions: res.sessions,
          meta: res.meta,
        });
      })
      .catch(() => {
        dispatch({
          type: actionTypes.IN_PERSON_TRAINING.EVENT.DATA_FAILURE,
        });
      });
  };
}
